"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TotalBalance = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ticker = require("../../../ticker");
var _ui = require("../../../ui");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var MediumSpan = (0, _styledComponents.default)(_ui.MediumSpan)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.tertiary;
});
var TotalBalance = function TotalBalance(_ref3) {
  var ticker = _ref3.ticker,
    value = _ref3.value,
    className = _ref3.className,
    _ref3$isMobile = _ref3.isMobile,
    isMobile = _ref3$isMobile === void 0 ? false : _ref3$isMobile;
  var _useTranslation = (0, _reactI18next.useTranslation)('libCommon'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: "m-0 d-flex align-items-end ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_ui.H4, {
    className: "m-0 me-2 text-nowrap"
  }, t(isMobile ? 'totalBalance' : 'totalPersonalBalance'), ":", ' '), value && /*#__PURE__*/_react.default.createElement(_ui.H4, {
    className: "m-0"
  }, /*#__PURE__*/_react.default.createElement(MediumSpan, {
    className: "text-nowrap"
  }, /*#__PURE__*/_react.default.createElement(_ticker.TickerSymbol, {
    ticker: ticker
  }), " ", /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    ticker: ticker,
    value: value
  }))));
};
exports.TotalBalance = TotalBalance;